import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY } from "@/data/site";

const SEO = ({ title, description, path = "/", schemaType = "LocalBusiness", extraSchema = null }) => {
  const url = `https://${COMPANY.website}${path}`;
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "MovingCompany",
    name: COMPANY.name,
    image: "https://customer-assets.emergentagent.com/job_premium-moving-wy/artifacts/63dddnb5_IMG_0277.webp",
    "@id": url,
    url: `https://${COMPANY.website}`,
    sameAs: [COMPANY.facebook, COMPANY.googleMaps],
    telephone: COMPANY.phone,
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress: "4941 Highway St",
      addressLocality: "Mills",
      addressRegion: "WY",
      postalCode: "82604",
      addressCountry: "US",
    },
    geo: { "@type": "GeoCoordinates", latitude: 42.8411, longitude: -106.3639 },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "00:00",
      closes: "23:59",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: `${COMPANY.rating}`,
      reviewCount: `${COMPANY.reviews}`,
    },
    areaServed: COMPANY.serviceAreas,
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="movers Casper WY, moving company Casper Wyoming, local movers Mills WY, residential movers Casper, office movers Wyoming, Crosstown Movers" />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow" />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={COMPANY.name} />
      <meta property="og:image" content="https://customer-assets.emergentagent.com/job_premium-moving-wy/artifacts/63dddnb5_IMG_0277.webp" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://customer-assets.emergentagent.com/job_premium-moving-wy/artifacts/63dddnb5_IMG_0277.webp" />

      <script type="application/ld+json">{JSON.stringify(defaultSchema)}</script>
      {extraSchema && <script type="application/ld+json">{JSON.stringify(extraSchema)}</script>}
    </Helmet>
  );
};

export default SEO;
